import { useContainer } from '#imports';
import { DependencyInjectId } from '@@/package/const/DependencyInjectId';
import SubscriptionMapper from '~~/package/mapper/subscription/SubscriptionMapper';
import { SubscriptionModel } from '~~/package/mapper/subscription/model/SubscriptionModel';
import PlanModel from '~~/package/mapper/subscription/model/PlanModel';
import { PageModel } from '~~/package/mapper/common/model/PageModel';
import { SubscriptionHistoryModel } from '~~/package/mapper/subscription/model/SubscriptionHistoryModel';
import type CreditPricingResponse from '~~/package/apis/subscription/response/CreditPricingResponse';

export const useSubscriptionService = () => {
    const subscriptionMapper = useContainer<SubscriptionMapper>(DependencyInjectId.SubscriptionMapper);

    const getCurrentSubscription = (): Promise<SubscriptionModel | null> => {
        return subscriptionMapper.getCurrentSubscription();
    };

    const getPlans = (): Promise<{ plans: PlanModel[]; country: string | null }> => {
        return subscriptionMapper.getPlans();
    };

    const cancelSubscription = (): Promise<SubscriptionModel> => {
        return subscriptionMapper.cancelSubscription();
    };

    const cancelCancellationRequest = (): Promise<SubscriptionModel> => {
        return subscriptionMapper.cancelCancellationRequest();
    };

    const restartSubscription = (): Promise<SubscriptionModel> => {
        return subscriptionMapper.restartSubscription();
    };

    const retryPayment = (): Promise<SubscriptionModel> => {
        return subscriptionMapper.retryPayment();
    };

    const getPaymentHistory = (page: number, size: number): Promise<PageModel<SubscriptionHistoryModel>> => {
        return subscriptionMapper.getPaymentHistory(page, size);
    };

    const getCreditPricing = (): Promise<CreditPricingResponse> => {
        return subscriptionMapper.getCreditPricing();
    };

    return { getCurrentSubscription, getPlans, cancelSubscription, cancelCancellationRequest, restartSubscription, retryPayment, getPaymentHistory, getCreditPricing };
};
